import { Fragment, useEffect } from 'react';
import { Provider } from 'react-redux';
import { BrowserRouter, Route, Routes } from 'react-router-dom';

// Components
import Alert from './components/layout/Alert';
import Layout from './components/layout/Layout';
import PrivateRoute from './components/routing/PrivateRoute';
import ValidateSession from './components/routing/ValidateSession';
import NoMatch from './components/routing/NoMatch';

// Login
import Login from './views/auth/Login';

// Dashboard
import Dashboard from './views/dashboard/Dashboard';

// Clientes
import Clientes from './views/clientes/Clientes';
import NuevoCliente from './views/clientes/NuevoCliente';
import EditarCliente from './views/clientes/EditarCliente';
import DetallesCliente from './views/clientes/DetallesCliente';

// Solicitudes WhatsApp
import SolicitudesWA from './views/solicitudes_wa/SolicitudesWA';

// Asesorias
import Asesorias from './views/asesorias/Asesorias';
import NuevaAsesoria from './views/asesorias/NuevaAsesoria';
import EditarAsesoria from './views/asesorias/EditarAsesoria';
import DetallesAsesoria from './views/asesorias/DetallesAsesoria';

// Usuarios
import Usuarios from './views/usuarios/Usuarios';
import NuevoUsuario from './views/usuarios/NuevoUsuario';
import EditarUsuario from './views/usuarios/EditarUsuario';

// Configuración
import Membresias from './views/configuracion/membresias/Membresias';
import Perfil from './views/configuracion/perfil/Perfil';

// Redux
import store from './store';
import { loadUser } from './actions/auth';
import setAuthToken from './utils/setAuthToken';

function App() {
	if (localStorage.token) {
		setAuthToken(localStorage.token);
	}

	useEffect(() => {
		store.dispatch(loadUser());
	}, []);

	return (
		<Provider store={store}>
			<BrowserRouter>
				<Fragment>
					<Layout></Layout>
					<section className="container-fluid principal-section">
						<Alert></Alert>

						<Routes>
							{/* Login */}
							<Route exact path="/" element={<ValidateSession><Login /></ValidateSession>}/>
							<Route exact path="/login" element={<ValidateSession><Login /></ValidateSession>}/>

							{/* Dashboard */}
							<Route path="/dashboard" element={<PrivateRoute routePermission=''><Dashboard /></PrivateRoute>}/>

							{/* Clientes */}
							<Route path="/clientes" element={<PrivateRoute routePermission='clientes.ver'><Clientes /></PrivateRoute>}/>
							<Route path="/clientes/nuevo" element={<PrivateRoute routePermission='clientes.agregar'><NuevoCliente /></PrivateRoute>}/>
							<Route path="/clientes/editar/:id" element={<PrivateRoute routePermission='clientes.editar'><EditarCliente /></PrivateRoute>}/>
							<Route path="/clientes/detalles/:id" element={<PrivateRoute routePermission='clientes.detalles'><DetallesCliente /></PrivateRoute>}/>

							{/* Solicitudes WhatsApp */}
							<Route path="/solicitudes_wa" element={<PrivateRoute routePermission='solicitudes.ver'><SolicitudesWA /></PrivateRoute>}/>

							{/* Asesorias */}
							<Route path="/asesorias" element={<PrivateRoute routePermission='asesorias.ver'><Asesorias /></PrivateRoute>}/>
							<Route path="/asesorias/nueva" element={<PrivateRoute routePermission='asesorias.agregar'><NuevaAsesoria /></PrivateRoute>}/>
							<Route path="/asesorias/editar/:id" element={<PrivateRoute routePermission='asesorias.editar'><EditarAsesoria /></PrivateRoute>}/>
							<Route path="/asesorias/detalles/:id" element={<PrivateRoute routePermission='asesorias.detalles'><DetallesAsesoria /></PrivateRoute>}/>

							{/* Usuarios */}
							<Route path="/usuarios" element={<PrivateRoute routePermission='usuarios.ver'><Usuarios /></PrivateRoute>}/>
							<Route path="/usuarios/nuevo" element={<PrivateRoute routePermission='usuarios.agregar'><NuevoUsuario /></PrivateRoute>}/>
							<Route path="/usuarios/editar/:id" element={<PrivateRoute routePermission='usuarios.editar'><EditarUsuario /></PrivateRoute>}/>

							{/* Configuración */}
							<Route path="/configuracion/membresias" element={<PrivateRoute routePermission='configuracion.membresias.ver'><Membresias /></PrivateRoute>}/>
							<Route path="/configuracion/perfil" element={<PrivateRoute routePermission='configuracion.perfil.ver'><Perfil /></PrivateRoute>}/>
							
							{/* Cuando no matchea con nada*/}
							<Route path="*" element={<NoMatch />}/>
						</Routes>
					</section>
				</Fragment>
			</BrowserRouter>
		</Provider>
	);
}

export default App;